import { render, staticRenderFns } from "./resignAlert.vue?vue&type=template&id=5ece12ee&scoped=true"
import script from "./resignAlert.vue?vue&type=script&lang=js"
export * from "./resignAlert.vue?vue&type=script&lang=js"
import style0 from "./resignAlert.vue?vue&type=style&index=0&id=5ece12ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ece12ee",
  null
  
)

export default component.exports